/**
 * infinite-scroll.js
 * ---------------------------------------------------------------
 * collection.liquid içindeki <infinite-scroll-loader> elementiyle çalışır.
 *
 * Beklenen markup:
 *   <infinite-scroll-loader
 *     data-mode="auto|button"
 *     data-next-url="/collections/x?page=2"
 *     data-section-id="...">
 *     <div data-infinite-scroll-sentinel></div>
 *     <div data-infinite-scroll-status hidden>...</div>
 *     <button data-infinite-scroll-button>...</button>   (sadece button modunda)
 *   </infinite-scroll-loader>
 *
 * Ürün grid'i: #CollectionLoop  (sarmalayıcı: [data-products-grid])
 */
(function () {
  'use strict';

  var GRID_SELECTOR = '#CollectionLoop';

  if (customElements.get('infinite-scroll-loader')) return;

  var InfiniteScrollLoader = function () {
    return Reflect.construct(HTMLElement, [], InfiniteScrollLoader);
  };

  InfiniteScrollLoader.prototype = Object.create(HTMLElement.prototype);
  InfiniteScrollLoader.prototype.constructor = InfiniteScrollLoader;
  Object.setPrototypeOf(InfiniteScrollLoader, HTMLElement);

  InfiniteScrollLoader.prototype.connectedCallback = function () {
    var self = this;

    this.nextUrl = this.dataset.nextUrl || null;
    this.mode = this.dataset.mode === 'button' ? 'button' : 'auto';
    this.loading = false;
    this.failed = false;

    this.sentinel = this.querySelector('[data-infinite-scroll-sentinel]');
    this.status = this.querySelector('[data-infinite-scroll-status]');
    this.button = this.querySelector('[data-infinite-scroll-button]');

    this.grid = document.querySelector(GRID_SELECTOR);

    // Grid bulunamazsa hiçbir şey yapma; sayfalama görünür kalsın.
    if (!this.grid || !this.nextUrl) return;

    // Infinite scroll devredeyse klasik sayfalama linklerini gizle.
    // (Hata olursa aşağıda tekrar gösteriliyor.)
    this.paginationNav = document.querySelector('[data-pagination-nav]');
    if (this.paginationNav && this.mode === 'auto') {
      this.paginationNav.hidden = true;
    }

    if (this.mode === 'button' && this.button) {
      this.button.addEventListener('click', function (e) {
        e.preventDefault();
        self.loadNext();
      });
      return;
    }

    // auto mod — sentinel görünür olunca yükle
    if ('IntersectionObserver' in window && this.sentinel) {
      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) self.loadNext();
          });
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this.sentinel);
    } else {
      // IntersectionObserver yoksa scroll'a düş
      this.onScroll = function () {
        if (self.loading || !self.nextUrl) return;
        var rect = self.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) self.loadNext();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  };

  InfiniteScrollLoader.prototype.disconnectedCallback = function () {
    if (this.observer) this.observer.disconnect();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  };

  InfiniteScrollLoader.prototype.setBusy = function (busy) {
    if (this.status) this.status.hidden = !busy;
    if (this.button) this.button.disabled = busy;
  };

  InfiniteScrollLoader.prototype.loadNext = function () {
    var self = this;

    if (this.loading || this.failed || !this.nextUrl) return;
    this.loading = true;
    this.setBusy(true);

    fetch(this.nextUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID_SELECTOR);

        if (!newGrid) throw new Error('Grid bulunamadı');

        var fragment = document.createDocumentFragment();
        Array.prototype.slice.call(newGrid.children).forEach(function (node) {
          // Tema animasyonları yeni eklenen düğümleri izlemediği için
          // animasyon attribute'larını temizliyoruz; aksi halde kartlar
          // opacity:0 kalıp "yüklenmiyor" gibi görünebiliyor.
          node.removeAttribute('data-animation');
          node.removeAttribute('data-animation-delay');
          node.removeAttribute('data-animation-duration');
          var inner = node.querySelectorAll('[data-animation]');
          Array.prototype.forEach.call(inner, function (el) {
            el.removeAttribute('data-animation');
            el.removeAttribute('data-animation-delay');
            el.removeAttribute('data-animation-duration');
          });
          fragment.appendChild(node);
        });

        self.grid.appendChild(fragment);

        // Sonraki sayfa URL'sini yeni sayfadaki loader'dan al
        var nextLoader = doc.querySelector('infinite-scroll-loader');
        var newNext = nextLoader ? nextLoader.getAttribute('data-next-url') : null;

        if (newNext && newNext !== self.nextUrl) {
          self.nextUrl = newNext;
          self.dataset.nextUrl = newNext;
        } else {
          // Son sayfa — yükleyiciyi kaldır
          self.nextUrl = null;
          if (self.observer) self.observer.disconnect();
          if (self.onScroll) window.removeEventListener('scroll', self.onScroll);
          self.remove();
        }

        // Renk/varyant filtre script'inin yeni kartlara da uygulanması için
        document.dispatchEvent(new CustomEvent('collection:filter:updated'));
      })
      .catch(function (err) {
        // Hata durumunda sayfalama linklerini geri göster ki
        // kullanıcı elle devam edebilsin.
        self.failed = true;
        if (self.paginationNav) self.paginationNav.hidden = false;
        if (self.observer) self.observer.disconnect();
        console.warn('[infinite-scroll]', err);
      })
      .then(function () {
        self.loading = false;
        self.setBusy(false);
      });
  };

  customElements.define('infinite-scroll-loader', InfiniteScrollLoader);
})();